import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';

class Prizes extends Component {
    render() {
        return (<h3 style={{backgroundColor: '#fff'}}>Prizes</h3>)
    }
}

const mapDispatchToProps = (dispatch) => {
    return {};
};
const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
    };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Prizes));


// WEBPACK FOOTER //
// ./src/components/prizes/index.js